import PrintIcon from '@mui/icons-material/Print';

import PrintingMethodList from "./PrintingMethodList"
import PrintingMethodCreate from "./PrintingMethodCreate"
import PrintingMethodEdit from "./PrintingMethodEdit"

const resource = {
  list: PrintingMethodList,  
  create: PrintingMethodCreate,
  edit: PrintingMethodEdit,
  icon: PrintIcon,
}

export default resource